import { render, staticRenderFns } from "./SaInfo.vue?vue&type=template&id=44a0c03f&scoped=true"
import script from "./SaInfo.vue?vue&type=script&lang=ts"
export * from "./SaInfo.vue?vue&type=script&lang=ts"
import style0 from "./SaInfo.vue?vue&type=style&index=0&id=44a0c03f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a0c03f",
  null
  
)

export default component.exports